import { EndpointsName } from '../../Auth/authTypes';
import { catchError } from "rxjs/operators";
import { get } from "../../Auth";

export const getMaintenanceInfo = () =>
get(EndpointsName.MAINTENANCE, '?factory=').pipe(
        catchError((err) => { throw err })
    )